import React, { Component } from 'react'
import { connect } from 'react-redux'
import PurchaseCorrectionSample from '../samples/PurchaseCorrectionSample'
import { makePurchaseCorrection, setErrorMessage } from '../../../actions/transactionsActions'
import { _DOTNET, _JAVA, _PHP, PURCHASE_CORRECTION_FAIL } from '../../../actions/types'

const CODES = {
    store_ID: ["mpgReq.SetStoreId(store_id);", "mpgReq.setStoreId(store_id);", "'store_id'=>$store_id"],
    API_token: ["mpgReq.SetApiToken(api_token);", "mpgReq.setApiToken(api_token);", "'api_token'=>$api_token"],
    status_check: ["mpgReq.SetStatusCheck(status_check);", "mpgReq.setStatusCheck(status_check);", "$mpgHttpPost = new mpgHttpsPostStatus\n($store_id,$api_token,$status,$mpgRequest);"],
    order_ID: ["purchasecorrection.SetOrderId(order_id);", "purchasecorrection.setOrderId(order_id);", "'order_id'=>$order_id"],
    transaction_number: ["purchasecorrection.SetTxnNumber(txn_number);", "purchasecorrection.setTxnNumber(txn_number);", "'txn_number'=>$txn_number"],
    electronic_commerce_indicator: ["purchasecorrection.SetCryptType(crypt);", "purchasecorrection.setCryptType(crypt);", "'crypt_type'=>$crypt"],
    customer_ID: ["purchasecorrection.SetCustId(cust_id);", "purchasecorrection.setCustId(cust_id);", "'cust_id'=>$cust_id"],
    dynamic_descriptor: ["purchasecorrection.SetDynamicDescriptor(dynamic_descriptor);", "purchasecorrection.setDynamicDescriptor(dynamic_descriptor);", "'dynamic_descriptor'=>$dynamic_descriptor"],
}

export class PurchaseCorrection extends Component {
    onMakePurchaseCorrectionPress() {
        const { storeId, apiToken, orderId, txnNumber, prevSuccStep } = this.props;
        if(txnNumber !== 'none' && [1, 3, 4].includes(prevSuccStep)) {
            this.setState({ showErr: false });
            const purchaseCorrectionRequest = { storeId, apiToken, orderId, txnNumber };
            this.props.makePurchaseCorrection(purchaseCorrectionRequest);
        }
        else {
            this.props.setErrorMessage("This transaction has a pre-requisite transaction: (Purchase or Pre-Authorization Completion or Force Post).", PURCHASE_CORRECTION_FAIL);
        }
    }

    renderIntegrationTool() {
        return (
            <div className="stepMainContainer">
                <h3>Sample Purchase Correction</h3>
                <PurchaseCorrectionSample />
                <div className="requestButton" onClick={() => this.onMakePurchaseCorrectionPress()}>
                        Purchase Correction Request
                </div>
            </div>
        );
    }

    renderDocument() {
        const { progLangId } = this.props;

        return (
            <div className="stepPageContainer">
                <span className="stepPageTitle"><b>Purchase Correction</b></span>
                <p style={{marginTop: '3vh'}}>Restores the full amount of a previous Purchase, Pre-Authorization Completion or Force Post transaction to the cardholder's card, and removes any record of it from the cardholder's statement.</p>
                <p>This transaction can be used against a Purchase or Pre-Authorization Completion transaction that occurred same day provided that the batch containing the original transaction remains open. When using the automated closing feature, Batch Close occurs daily between 10 and 11 pm Eastern Time.</p>
                
                <div className='thingsToConsider'>
                    <b>Things to Consider: </b>
                    <ul>
                        <li>To process this transaction, you need the order ID and the transaction number from the original Completion, Purchase or Force Post transaction.</li>
                    </ul>
                </div>

                <p><b>Purchase Correction transaction object definition</b></p>
                {(() => {
                switch(progLangId) {
                    case _DOTNET:
                        return <code>PurchaseCorrection purchasecorrection = new PurchaseCorrection();</code>
                    case _JAVA:
                        return <code>PurchaseCorrection purchasecorrection = new PurchaseCorrection();</code>
                    case _PHP:
                        return <code>$txnArray = array(‘type’=>’purchasecorrection', …);<br />$mpgTxn = new mpgTransaction($txnArray);</code>
                    default:
                        return null
                    }
                })()}

                <p style={{ marginTop: '5vh'}}><b>HttpsPostRequest object for Purchase Correction transaction</b></p>
                {(() => {
                switch(progLangId) {
                    case _DOTNET:
                        return <code>HttpsPostRequest mpgReq = new HttpsPostRequest();<br />mpgReq.SetTransaction(purchasecorrection);</code>
                    case _JAVA:
                        return <code>HttpsPostRequest mpgReq = new HttpsPostRequest();<br />mpgReq.setTransaction(purchasecorrection);</code>
                    case _PHP:
                        return <code>$mpgRequest = new mpgRequest($mpgTxn);<br />$mpgHttpPost = new mpgHttpsPost($store_id,$api_token,$mpgRequest);</code>
                    default:
                        return null
                    }
                })()}

                <h3 style={{ marginTop: '7vh'}}>Core connection object fields (all API transactions)</h3>
                <table>
                    <th>Variable Name</th>
                    <th>Type and Limits</th>
                    <th>Set Method</th>

                    <tr>
                        <td>store ID</td>
                        <td><i>String</i><br /><br /> N/A</td>
                        <td><code>{CODES.store_ID[progLangId]}</code></td>
                    </tr>

                    <tr>
                        <td>API token</td>
                        <td><i>String</i><br /><br /> N/A</td>
                        <td><code>{CODES.API_token[progLangId]}</code></td>
                    </tr>
                </table>

                <h3 style={{ marginTop: '7vh'}}>Optional connection object field</h3>
                <table>
                    <th>Variable Name</th>
                    <th>Type and Limits</th>
                    <th>Set Method</th>

                    <tr>
                        <td>status check</td>
                        <td><i>Boolean</i><br /><br />true/false</td>
                        <td><code>{CODES.status_check[progLangId]}</code></td>
                    </tr>
                </table>

                <h3 style={{ marginTop: '7vh'}}>Purchase Correction transaction request fields – Required</h3>
                <table>
                    <th>Variable Name</th>
                    <th>Type and Limits</th>
                    <th>Set Method</th>

                    <tr>
                        <td>order ID</td>
                        <td><i>String</i><br /><br />50-character alphanumeric<br />a-Z A-Z 0-9 _ - : . @ spaces</td>
                        <td><code>{CODES.order_ID[progLangId]}</code></td>
                    </tr>
                    <tr>
                        <td>transaction number</td>
                        <td><i>String</i><br /><br />255-character, alphanumeric, hyphens or underscores<br />variable length</td>
                        <td><code>{CODES.transaction_number[progLangId]}</code></td>
                    </tr>
                    <tr>
                        <td>electronic commerce indicator</td>
                        <td><i>String</i><br /><br />1-character alphanumeric</td>
                        <td><code>{CODES.electronic_commerce_indicator[progLangId]}</code></td>
                    </tr>
                </table>
                
                <h3 style={{ marginTop: '7vh'}}>Purchase Correction transaction request fields – Optional</h3>
                <table>
                    <th>Variable Name</th>
                    <th>Type and Limits</th>
                    <th>Set Method</th>

                    <tr>
                        <td>customer ID</td>
                        <td><i>String</i><br /><br />50-character alphanumeric</td>
                        <td><code>{CODES.customer_ID[progLangId]}</code></td>
                    </tr>
                    <tr>
                        <td>dynamic descriptor</td>
                        <td><i>String</i><br /><br />20-character alphanumeric</td>
                        <td><code>{CODES.dynamic_descriptor[progLangId]}</code></td>
                    </tr>
                </table>
            </div>
        )
    }

    render() {
        const { mode } = this.props;
        if(mode === 'interactive_tool')
            return this.renderIntegrationTool();
        else if(mode === 'integration_guide')
            return this.renderDocument();
        else {
            return null;
        }
    }
}

const mapStateToProps = state => {
    const { mode } = state.common.sideNav;
    const { storeId, apiToken, orderId, txnNumber } = state.transactions.main.config;
    const { prevSuccStep } = state.transactions.main;
    return { prevSuccStep, mode, storeId, apiToken, orderId, txnNumber, progLangId: state.common.progLangList.selection };
}

export default connect(mapStateToProps, {makePurchaseCorrection, setErrorMessage})(PurchaseCorrection)
